import HTTP from "@/http-common";
import { httpError } from "@/models/httpError";

export const state = {
  rows: [{}],
  id: "",
  item: [],
  excludeds: [],
  isWholesaler: false,
  payTerm: 0,
  agedReceivables: [],
  message: new httpError()
};

export const getters = {
  isWholesaler: state => {
    return state.isWholesaler;
  },
  payTerm: state => {
    return state.payTerm;
  },
  agedReceivables: state => {
    return state.agedReceivables;
  },
  message: state => state.message
};

export const mutations = {
  setProgress(state, message) {
    state.message = message;
  },
  setAgedReceivables(state, data) {
    state.agedReceivables = data;
  },
  updateWholesalerState(state, wholesaler) {
    state.isWholesaler = wholesaler;
  },
  updatePayTermState(state, payTerm) {
    state.payTerm = payTerm;
  }
};

export const actions = {
  setMessage({ commit }, message) {
    commit("setProgress", message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit("setProgress", new httpError());
      }, 5000);
  },
  getReminders({ dispatch }, data) {
    if (!data.stage) data.stage = "none";
    return new Promise((resolve, reject) => {
      let url = data.showExcluded
        ? "GetExcludedAgedReceivables"
        : `GetReminders/${data.showExcluded}/${data.stage}`;
      HTTP.get(`reminder/${url}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  getRemindersForStage({ dispatch }, stage) {
    return new Promise((resolve, reject) => {
      let url = `GetRemindersForStage/${stage}`;
      HTTP.get(`reminder/${url}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  getExcludedCustomers({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/GetExcludedAgedReceivables")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  loadAuditLog({ dispatch }, query) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/GetAuditLogs", query)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  getFinancials({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/GetFinancials", item)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  loadExcludedGroups({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get("reminder/GetGroups")
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  updateGroupStatus({ }, id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`reminder/UpdateGroupStatus/${id}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  processReminders({ dispatch }, formData) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/ProcessReminders", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      })
        .then(data => {
          if (data.status === 200) {
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },

  excludeCustomer({ dispatch }, custNo) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/ExcludeCustomer/" + custNo)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  updateExcludeStatus({ dispatch }, item, type) {
    if (typeof item.number === "undefined") {
      item.number = item.customerNo;
    }

    return new Promise((resolve, reject) => {
      HTTP.post("reminder/UpdateExclude", {
        name: item.name,
        number: item.number,
        excludedType: type
      })
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  includeCustomer({ dispatch }, custNo) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/IncludeCustomer/" + custNo)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  updateUploadsOnOrder({ commit, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        "order/UploadFilesByGuid/00000000-0000-0000-0000-000000000000",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      )
        .then(data => {
          if (data.status === 200) {
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },

  sendReminders({ dispatch }, reminders) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/SendRemindersAsync", reminders)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  updateNoLatePayment({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/UpdateNoLatePaymentFee", item, {
        custNo: item.customerNo,
        noLatePaymentFee: item.latePayment
      })
        .then(data => {
          if (data.status === 200) {
            resolve(data.data);
          }
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({ message: err.message, httpStatus: 500 })
          );
          reject(err);
        });
    });
  },
  updateNoLatePaymentFee({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `reminder/UpdateNoLatePaymentFee/${item.customerNo}/${item.noLatePaymentFee}`
      )
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  updateTempNoLatePaymentFee({ }, item) {
    return new Promise((resolve, reject) => {
      HTTP.post(`reminder/UpdateTempNoLatePaymentFee`, {
        customerNo: item.customerNo,
        active: item.tempNoLatePaymentFeeActive,
        activeFromDate: item.tempNoLatePaymentActiveFrom
      })
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  DeleteTempNoLatePaymentFee({ }, item) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`reminder/DeleteTempNoLatePaymentFee/${item.customerNo}`, {
        data: item
      })
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  RetrieveCustomer({ }, item) {
    if (!item) return;

    return new Promise((resolve, reject) => {
      HTTP.get(`customer/GetCustomerByAccountNumber/${item}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  getServices({ }, accountNumber) {
    return new Promise((resolve, reject) => {
      HTTP.get("vodia/GetCustomerServices/" + accountNumber)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  RequestCustomerDispute({ }, selected) {
    return new Promise((resolve, reject) => {
      HTTP.post(`reminder/RequestCustomerDispute`, selected)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  SendCustomerDispute({ }, selected) {
    return new Promise((resolve, reject) => {
      HTTP.post(
        `reminder/SendCustomerDispute/${selected.ticketID}`,
        selected.data
      )
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  sendEmailTest({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post("reminder/SendEmailTest", data)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },

  getWholesalerReminders({ dispatch }, data) {
    if (!data.stage) data.stage = "none";
    return new Promise((resolve, reject) => {
      let url = data.showExcluded
        ? "GetExcludedAgedReceivables"
        : `GetWholesalerReminders/${data.showExcluded}/${data.stage}/${data.payTerm}`;
      HTTP.get(`reminder/${url}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  getWholesalerRemindersForStage({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      let url = `GetWholesalerRemindersForStage/${data.stage}/${data.payTerm}`;
      HTTP.get(`reminder/${url}`)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  importAgedReceivables({ commit }) {
    return new Promise((resolve, reject) => {
      HTTP.get(`reminder/GetAgedReceivablesByDateReport`)
        .then(data => {
          commit("setAgedReceivables", data.data);
          resolve(data.data);
        })
        .catch(err => {
          reject(err.message);
        });
    });
  },
  getUBCustomers({ dispatch }) {
    return new Promise((resolve, reject) => {
      HTTP.get(`reminder/GetUBCustomers`)
        .then(data => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Retrieved customer list successfully!",
              httpStatus: 200
            })
          );
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Failed retrieving customers",
              httpStatus: 500
            })
          );
          reject(err.message);
        });
    });
  },
  getUBStatements({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      HTTP.post(`reminder/GetUBStatementsforLetter`, data)
        .then(data => {
          resolve(data.data);
        })
        .catch(err => {
          dispatch(
            "setMessage",
            new httpError({
              message: "Error in retrieving invoices:" + err.message,
              httpStatus: 500
            })
          );
          reject(err.message);
        });
    });
  },
  addMFAToUser({ dispatch }, email) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post(`Auth/AddMFAToUser`, { email });
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 200,
              message: 'User enrolled in MFA',
            })
          );
          resolve('User enrolled in MFA');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              httpStatus: 400,
              message: 'Request Failed: ' + err.message,
            })
          );
          reject('Request Failed: ' + err.message);
        });
    });
  },
};
